<ul class="route-list p-4">
  @for (route of routes; track route.path) {
  <li>
    <a [routerLink]="route.path" routerLinkActive="active">{{ route.label }}</a>
  </li>
  }
</ul>
